import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { connect } from 'react-redux';
import theme, { textBold } from 'theme/theme';
import TagManager from "react-gtm-module";
import MainTitle from 'base/components/MainTitle';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import SubmitButton from 'base/components/forms/SubmitButton';
import SpinnerOverlay from 'base/components/SpinnerOverlay';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import SplashScreen from 'auth/components/SplashScreen';
import { forgotPassword } from '../../store/auth/actions';
import {tagManagerArgs} from "../../../index";
import {
  getForgotPasswordHasError,
  getForgotPasswordIsLoading,
  getForgotPasswordIsSuccess,
} from '../../store/auth/selectors';



const ErrorMessage = styled.div`
  margin: 0 0 2rem 0;
  ${textBold};
  color: ${theme.colors.primary};
`;


const LoginForm = ({ isSubmitting }) => ( // eslint-disable-line
  <Form>
    <FieldWrapper>
        Enter your email address and we will send you a link to reset your password.
    </FieldWrapper>
    <Field
      type="text"
      name="email"
      placeholder="Email"
      component={FormikInputField}
    />
    <SubmitButton type="submit" disabled={isSubmitting}>
        Send reset link
    </SubmitButton>


  </Form>
);

const ForgotPassword = ({
  isLoading, forgotPassword, hasError, isSuccess,
}) => {

    const args = {
        ...tagManagerArgs,
        events: {
            forgotPassword: 'forgotPassword'
        }
    }

    const successContent = (
    <>
      <MainTitle withSpaceBelow>Success</MainTitle>
        Reset link has been sent to your email.
    </>
  );

  const formContent = (
    <>
      <MainTitle withSpaceBelow>Forgot password</MainTitle>
      {hasError && (<ErrorMessage>No active user found</ErrorMessage>)}
      {isLoading
        ? <SpinnerOverlay label="Submitting" />
        : (
          <Formik
            initialValues={{
              email: '',
            }}
            validationSchema={
                      Yup.object().shape({
                        email: Yup.string()
                          .required('Email is required.')
                          .email('Please enter a valid email'),
                      })
                    }
            render={LoginForm}
            onSubmit={(values) => {
              TagManager.initialize(args)
              forgotPassword({ email: values.email });
            }}
          />
        )}
    </>
  );

  return (
    <SplashScreen>
      {isSuccess ? successContent : formContent}
    </SplashScreen>
  );
};
ForgotPassword.propTypes = {
  forgotPassword: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isLoading: getForgotPasswordIsLoading(state),
  isSuccess: getForgotPasswordIsSuccess(state),
  hasError: getForgotPasswordHasError(state),
});

const mapDispatchToProps = {
  forgotPassword,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPassword);
